<template>
    <div>
        <div class="row" style="font-size: 12px; white-space: nowrap">
            <div class="col-md-12 mb-4">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 pr-md-5">
                                <!-- inserted_by -->
                                <div class="d-flex mb-2">
                                    <div class="w-50 lh uc">Venditore</div>
                                    <div class="w-50">
                                        <select class="form-control" v-model="property.inserted_by">
                                            <option :value="null" disabled>-</option>
                                            <option v-for="o in insertedByOptions" :key="o.value" :value="o.value">{{
                                                    o.label
                                            }}</option>
                                        </select>
                                    </div>
                                </div>

                                <!-- idv_renovation_type -->
                                <div class="d-flex mb-2">
                                    <div class="w-50 lh uc">
                                        Ristrutturazione
                                    </div>
                                    <div class="w-50">
                                        <select class="form-control" v-model="
                                            property.idv_renovation_type
                                        ">
                                            <option :value="null" disabled>-</option>
                                            <option v-for="o in renovationOptions" :key="o.value" :value="o.value">{{
                                                    o.label
                                            }}</option>
                                        </select>
                                    </div>
                                </div>

                                <!-- idv_renovation_surface -->
                                <div class="d-flex mb-2">
                                    <div class="w-50 lh uc">
                                        Mq da ristrutturare
                                    </div>
                                    <div class="w-50">
                                        <div class="input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">Mq</span>
                                            </div>
                                            <input type="number" class="form-control" v-model="
                                                property.idv_renovation_surface
                                            " />
                                        </div>
                                    </div>
                                </div>

                                <!-- actual_agency_price -->
                                <div class="d-flex mb-2">
                                    <div class="w-50 lh uc">
                                        Prezzo acquisto immobile
                                    </div>
                                    <div class="w-50">
                                        <currency-input unit="€" v-model="property.idv_buy_price" />
                                    </div>
                                </div>

                                <!-- after_restoration_agency_price -->
                                <div class="d-flex mb-2">
                                    <div class="w-50 lh uc">
                                        Prezzo di vendita immobile
                                    </div>
                                    <div class="w-50">
                                        <currency-input unit="€" v-model="property.idv_sell_price" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 pl-md-5">
                                <!-- address -->
                                <div class="d-flex mb-2">
                                    <div class="lh uc">Indirizzo</div>
                                    <div style="flex: 1">
                                        <vue-google-autocomplete class="form-control" @place_changed="getAddressData"
                                            placeholder="via Europa 30, Torino (TO)"></vue-google-autocomplete>
                                    </div>
                                </div>

                                <!-- source -->
                                <div class="d-flex mb-2">
                                    <div class="lh uc">Fonte</div>
                                    <div style="flex: 1">
                                        <select class="form-control" v-model="property.source">
                                            <option v-for="o in sourceOptions" :key="o.value" :value="o.value">{{
                                                    o.label
                                            }}</option>
                                        </select>
                                    </div>
                                </div>

                                <!-- partner -->
                                <div class="d-flex mb-2">
                                    <div class="lh uc">Partner</div>
                                    <div style="flex: 1">
                                        <select class="form-control" v-model="property.agency_id">
                                            <option v-for="a in agencies" :key="a.id" :value="a.id">
                                                {{ getPartnerName(a) }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <!-- notes -->
                                <div class="d-flex mb-2">
                                    <div class="lh uc">Note</div>
                                    <div style="flex: 1">
                                        <textarea class="form-control" style="min-height: 5.75rem"
                                            v-model="property.notes" placeholder="Inserisci nota"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- BUY -->
            <div class="col-md-4 col-12 mb-4">
                <div class="card h-100 custom-card red">
                    <div class="card-header">
                        <h3>Acquisto</h3>
                    </div>
                    <div class="card-body">
                        <div v-for="(cat, ckey) in fakeBP.buy" :key="ckey" class="row no-gutters align-items-center">
                            <div class="col-7 uc" style="white-space: normal;">
                                {{ cat.label }}
                            </div>
                            <div class="col-5">
                                <div class="d-flex justify-content-end">
                                    <span class="mr-1">€</span>
                                    <span>{{ numf(cat.data) }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="row no-gutters align-items-center pt-3 mt-3 border-top">
                            <div class="col uc">Totale costi acquisto</div>
                            <div class="col">
                                <div class="d-flex justify-content-end">
                                    <h3 class="mb-0 text-dark">
                                        <span class="mr-1">€</span>
                                        {{ numf(getBuyTotal()) }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- SELL -->
            <div class="col-md-4 col-12 mb-4">
                <div class="card h-100 custom-card green">
                    <div class="card-header">
                        <h3>Vendita</h3>
                    </div>
                    <div class="card-body">
                        <div v-for="(cat, ckey) in fakeBP.sell" :key="ckey" class="row no-gutters align-items-center">
                            <div class="col-7 uc" style="white-space: normal;">
                                {{ cat.label }}
                            </div>
                            <div class="col-5">
                                <div class="d-flex justify-content-end">
                                    <span class="mr-1">€</span>
                                    <span>{{ numf(cat.data) }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="row no-gutters align-items-center pt-3 mt-3 border-top">
                            <div class="col uc">margine commerciale</div>
                            <div class="col">
                                <div class="d-flex justify-content-end">
                                    <h3 class="mb-0 text-dark">
                                        <span class="mr-1">€</span>
                                        {{ numf(getSellMargin()) }}
                                    </h3>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-4">
                <div class="card gray mb-4">
                    <div class="card-body">
                        <div class="row mb-2">
                            <div class="col-6 uc"><b>Utile lordo</b></div>
                            <div class="col-6 text-primary">
                                € {{ numf(getIncome()) }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-6 uc"><b>% ROI</b></div>
                            <div class="col-6 text-primary">
                                {{ numf(getROI()) }}%
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-right">
                    <button class="btn btn-primary" @click="confirmSave" :disabled="isSaving">
                        <span v-if="isSaving" class="mr-2">
                            <div class="spinner-border text-light"
                                style="height: 1rem; width: 1rem; border-width: 0.15em" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </span>
                        Aggiungi immobile
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    inserted_by_options,
    renovation_options,
    source_options
} from "@/helpers/select-options";
import { numf } from "@/helpers/helper";
import * as VueGoogleMaps from "vue2-google-maps";

const resetter = {
    municipality_id: null,
    is_complete: true,
    municipality: null,
    address: null,
    house_number: null,
    postal_code: null,
    province: null,
    region: null,
    country: null,
    inserted_by: null,
    notes: null,
    idv_buy_price: null,
    idv_sell_price: null,
    idv_renovation_type: null,
    idv_renovation_surface: null
};

export default {
    components: {
        "vue-google-autocomplete": VueGoogleMaps.Autocomplete
    },

    data() {
        return {
            isSaving: false,
            insertedByOptions: inserted_by_options,
            renovationOptions: renovation_options,
            sourceOptions: source_options,
            property: { ...resetter },
            agencies: [],
            fakeBP: {
                buy: {
                    acquisto_immobile: {
                        label: "Prezzo immobile",
                        data: 0
                    },
                    costo_commerciale: {
                        label: "Costo commerciale - Acquisto",
                        data: 0
                    },
                    costo_renovation: {
                        label: "Costo ristrutturazione",
                        data: 0
                    },
                    oneri_finanziari: {
                        label: "Oneri finanziari",
                        data: 0
                    }
                },
                sell: {
                    ricavi_vendita: {
                        label: "Prezzo di vendita immobile",
                        data: 0
                    },
                    costo_commerciale_vendita: {
                        label: "Costo commerciale - Vendita",
                        data: 0
                    }
                }
            }
        };
    },

    mounted() {
        this.agencies = this.$page.props.agencies;
    },

    watch: {
        property: {
            handler() {
                this.fakeBP.buy.acquisto_immobile.data = this.acquisto_immobile();
                this.fakeBP.buy.costo_commerciale.data = this.costo_commerciale();
                this.fakeBP.buy.costo_renovation.data = this.costo_renovation();
                this.fakeBP.buy.oneri_finanziari.data = this.oneri_finanziari();
                this.fakeBP.sell.ricavi_vendita.data = this.ricavi_vendita();
                this.fakeBP.sell.costo_commerciale_vendita.data = this.costo_commerciale_vendita();
            },
            deep: true
        }
    },

    methods: {
        numf,

        acquisto_immobile() {
            const percent = 0.09
            return (
                Number(this.property.idv_buy_price) +
                Number(this.property.idv_buy_price) * percent +
                Number(this.property.idv_buy_price) * 0.02
            );
        },
        costo_commerciale() {
            return Number(this.property.idv_buy_price) * 0.02;
        },
        costo_renovation() {
            switch (this.property.idv_renovation_type) {
                case "fractioning":
                    return this.property.idv_renovation_surface * 400;
                case "complete_no_fixtures":
                    return this.property.idv_renovation_surface * 500;
                case "complete":
                    return this.property.idv_renovation_surface * 600;
                case "use_change":
                    return this.property.idv_renovation_surface * 800;
                default:
                    return 0;
            }
        },
        oneri_finanziari() {
            return Number(this.property.idv_buy_price) * 0.02;
        },
        ricavi_vendita() {
            return Number(this.property.idv_sell_price);
        },
        costo_commerciale_vendita() {
            return Number(this.property.idv_sell_price) * 0.02;
        },

        getAddressData(payload) {
            const city = this.getAddressComponent(payload, "locality");
            const address = this.getAddressComponent(payload, "route");
            const number = this.getAddressComponent(payload, "street_number");
            const postal_code = this.getAddressComponent(
                payload,
                "postal_code"
            );
            const province = this.getAddressComponent(
                payload,
                "administrative_area_level_2"
            );
            const region = this.getAddressComponent(
                payload,
                "administrative_area_level_1"
            );
            const country = this.getAddressComponent(payload, "country");
            this.property.municipality = city == null ? "" : city.short_name;
            this.property.address = address == null ? "" : address.short_name;
            this.property.house_number =
                number == null ? "" : number.short_name;
            this.property.postal_code =
                postal_code == null ? "" : postal_code.short_name;
            this.property.province =
                province == null ? "" : province.short_name;
            this.property.region = region == null ? "" : region.short_name;
            this.property.country = country == null ? "" : country.short_name;
        },
        getAddressComponent(payload, type) {
            let { address_components } = payload;
            return address_components.filter(i => i.types.includes(type))[0];
        },

        getBuyTotal() {
            return (
                this.fakeBP.buy.acquisto_immobile.data +
                this.fakeBP.buy.costo_commerciale.data +
                this.fakeBP.buy.costo_renovation.data +
                this.fakeBP.buy.oneri_finanziari.data
            );
        },
        getSellMargin() {
            return (
                this.fakeBP.sell.ricavi_vendita.data -
                this.fakeBP.sell.costo_commerciale_vendita.data
            );
        },
        getIncome() {
            return this.getSellMargin() - this.getBuyTotal();
        },
        getROI() {
            if (this.getBuyTotal() == 0) return 0;
            return (this.getIncome() / this.getBuyTotal()) * 100;
        },

        getPartnerName(agency) {
            if (agency.agency_name) return agency.agency_name;
            if (agency.company_name) return agency.company_name;
            return agency.name;
        },

        confirmSave() {
            this.$confirm({
                message: `Salvare una nuova proprietà con questi dati?`,
                button: {
                    no: "No",
                    yes: "Si"
                },
                callback: confirm => {
                    if (confirm) {
                        this.save();
                    }
                }
            });
        },
        async save() {
            this.isSaving = true;

            try {
                this.property.surface = this.property.idv_renovation_surface;

                this.$inertia.post(`/admin/instant-deal-value`, this.property, {
                    onSuccess: (response) => {
                        this.$confirm({
                            message: `Immobile aggiunto correttamente, andare alla scheda?`,
                            button: {
                                no: "No",
                                yes: "Si"
                            },
                            callback: confirm => {
                                if (confirm)
                                    this.$inertia.visit(
                                        `/admin/properties/${response.props.flash}`
                                    );
                            }
                        });
                    }
                });

            } catch (error) {
                console.log(error);
            }

            this.property = { ...resetter };
            this.isSaving = false;
        }
    }
};
</script>

<style lang="scss" scoped>
.lh {
    line-height: 2.8rem;
    min-width: 8rem;
}

.uc {
    text-transform: uppercase;
}

.card.gray {
    background-color: #f7f7f7;
}
</style>
